import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8v4yrvb98p: FaireBrandEntity = {
  token: "b_8v4yrvb98p",
  type: "brand",
  name: "Kosterina",
  avatarUrl:
    "https://cdn.faire.com/fastly/8268761e4f977d4b0168c1d7805dbd909fcb6025577b887b6dca923c59cf6b1f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/827d85fa3b21690e84a69165bc791712c43f1ea586a488a7e1b6ce945dacf90c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8268761e4f977d4b0168c1d7805dbd909fcb6025577b887b6dca923c59cf6b1f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/827d85fa3b21690e84a69165bc791712c43f1ea586a488a7e1b6ce945dacf90c.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 69,
  rating: 4.9,
  reviewCount: 39,
  isTopShop: true,
  isInsider: true,
  description:
    "Kosterina products are crafted to deliver on the promise of the Mediterranean lifestyle, with 100% pure and authentically extra virgin olive oil at the center.\n\nCrafted in small batches in Southern Greece, our extra virgin olive oil is cold pressed from early harvest olives to preserve the abundant levels of polyphenols — naturally-occurring antioxidants with unrivaled health benefits. This ultra-special EVOO inspires all of our products and is at the center of the Mediterranean lifestyle. Our products offer a modern twist on the classics, always staying true to our Mediterranean heritage.\n\nFrom our Founder: In 2020, I started Kosterina after years of enjoying EVOO pressed from our families' olive trees in Southern Greece. We could never find a proper substitute here in the States for the fresh, delicious Greek EVOO we knew and loved, so we partnered with farmers in the region to develop an authentic Greek Extra Virgin Olive Oil for the US market. As we began development, I became an olive oil sommelier and soon discovered that the majority of the olive oils here in the US are label Extra Virgin but are not. This fueled my efforts to help bring authentic, high quality Extra Virgin olive oil to our wider community, so they may enjoy the life-enhancing benefits of this golden elixir. Every product we've developed since similarly focuses on helping our community achieve a healthier, more enjoyable life.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:27.754Z",
    importedBy: "entity-db-cli",
  },
};
